import type { ParticipantId, WallCard } from '@walls/store';

export function isCardVisibleForParticipantFilter(
  card: Pick<WallCard, 'ownerId'>,
  visibleParticipantIds: ParticipantId[]
) {
  return (
    visibleParticipantIds.length === 0 ||
    Boolean(card.ownerId && visibleParticipantIds.includes(card.ownerId))
  );
}

export function isBoardElementVisibleForParticipantFilter(
  card: Pick<WallCard, 'cards' | 'ownerId' | 'persistCluster'>,
  visibleParticipantIds: ParticipantId[]
): boolean {
  if (card.persistCluster || card.cards.length > 0) {
    return true;
  }

  return isCardVisibleForParticipantFilter(card, visibleParticipantIds);
}

export function isConnectionVisibleForParticipantFilter(
  startCard: Pick<WallCard, 'cards' | 'ownerId' | 'persistCluster'>,
  endCard: Pick<WallCard, 'cards' | 'ownerId' | 'persistCluster'>,
  visibleParticipantIds: ParticipantId[]
) {
  return (
    isBoardElementVisibleForParticipantFilter(startCard, visibleParticipantIds) &&
    isBoardElementVisibleForParticipantFilter(endCard, visibleParticipantIds)
  );
}
